import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: [{ value: 'UPPER_LEFT', label: '左上' }],
    blue: [
        { value: 'UPPER_LEFT', label: '左上' },
        { value: 'UPPER_RIGHT', label: '右上' },
        { value: 'LOWER_LEFT', label: '左下' },
        { value: 'LOWER_RIGHT', label: '右下' },
    ],
};

const TYPE_OPTIONS = [
    { value: 'X', label: 'X軸周りの角度' },
    { value: 'Y', label: 'Y軸周りの角度' },
    { value: 'Z', label: 'Z軸周りの角度' },
];

const TYPE_COLOURS: Record<string, string> = {
    X: '#cc0000',
    Y: '#00cc00',
    Z: '#0000cc',
};

function applyBoardToPositionField(block: Blockly.Block, board: 'orange' | 'blue'): void {
    const field = block.getField('POSITION') as FieldOperatorDropdown | null;
    if (!field) return;
    field.setOptions([...POSITION_OPTIONS[board]]);
    field.setValue(POSITION_OPTIONS[board][0].value);
    (block as Blockly.BlockSvg).render();
}

defineBlock({
    type: 'accelerometer_angle',
    colour: CATEGORIES.sensing.color,
    tooltip: '加速度センサーの角度を読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/accelerometer.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('加速度センサー', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('角度'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'POSITION',
                    instance: () => new FieldOperatorDropdown(POSITION_OPTIONS.orange),
                },
                { type: 'label', text: 'で' },
                {
                    type: 'field',
                    name: 'TYPE',
                    instance: () => {
                        const field = new FieldOperatorDropdown(TYPE_OPTIONS);
                        field.setRectColour(CATEGORIES.sensing.color);
                        field.setOnValueChange((value: string) => {
                            field.setRectColour(TYPE_COLOURS[value]);
                        });
                        return field;
                    },
                },
                { type: 'label', text: 'を計測する ' },
            ],
        },
    ],
    onBoardChange: (block, board) => {
        applyBoardToPositionField(block, board);
    },
    onInit(this: Blockly.Block) {
        if ((this.workspace as Blockly.WorkspaceSvg).isFlyout) return;
        this.workspace.addChangeListener((event: Blockly.Events.Abstract) => {
            if (event.type !== Blockly.Events.BLOCK_CREATE) return;
            if ((event as any).blockId !== this.id) return;
            const field = this.getField('TYPE') as FieldOperatorDropdown | null;
            if (!field) return;
            field.setRectColour(TYPE_COLOURS[this.getFieldValue('TYPE')]);
            (this as Blockly.BlockSvg).render();
        });
    },
});
